module.exports = __webpack_public_path__ + "img/garrafas-todas-cerradas-560.f5da403f.png";